(() => {
  if (customElements.get('mm-cart-shipping-rate') || !window.MMShipping) return;
  const {ShippingElement, request, root} = window.MMShipping;
  // Shopify can refresh discount keys while preparing rates. Compare the monetary
  // effect, allocation and merchandise, rather than transient discount metadata.
  const signature = cart => JSON.stringify({currency: cart.currency, total: cart.total_price,
    discounts: (cart.cart_level_discount_applications || []).map(discount => JSON.stringify({
      target: discount.target_type, selection: discount.target_selection, allocation: discount.allocation_method,
      value: discount.value, valueType: discount.value_type, amount: discount.total_allocated_amount
    })).sort(), items: cart.items?.map(item => [item.key, item.quantity, item.final_line_price])});
  class MMCartShippingRate extends ShippingElement {
    connectedCallback() {
      super.connectedCallback();
      this._cartChange = () => this.invalidate();
      this.cartEvent = typeof CART_EVENT === 'object' ? CART_EVENT.cartUpdate : 'cart:updated';
      document.addEventListener(this.cartEvent, this._cartChange);
    }
    disconnectedCallback() {
      super.disconnectedCallback();
      document.removeEventListener(this.cartEvent, this._cartChange);
    }
    async cart(signal) {
      return (await request(`${root()}cart.js`, {credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}}, signal)).json();
    }
    async context(signal) {
      const cart = await this.cart(signal);
      if (!cart.item_count) throw new Error('EMPTY_CART');
      return {signature: signature(cart), currency: cart.currency};
    }
    async matches(context, signal) { return context.signature === signature(await this.cart(signal)); }
    formatDeliveryDate(value) {
      const original = String(value);
      if (!/^\d{4}-\d{2}-\d{2}(?:T.*)?$/.test(original)) return original;
      const datePart = original.slice(0, 10);
      const date = new Date(`${datePart}T12:00:00Z`);
      if (!Number.isFinite(date.getTime()) || date.toISOString().slice(0, 10) !== datePart) return original;
      return new Intl.DateTimeFormat('pt-BR', {day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'UTC'}).format(date);
    }
    async rates(context, zip, address, signal) {
      const params = new URLSearchParams({'shipping_address[country]': 'BR',
        'shipping_address[province]': address.uf, 'shipping_address[zip]': zip,
        'shipping_address[city]': address.localidade});
      await request(`${root()}cart/prepare_shipping_rates.json`, {
        method: 'POST', credentials: 'same-origin',
        headers: {'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8', Accept: 'application/json'},
        body: params.toString()
      }, signal);
      for (let attempt = 0; attempt < 24; attempt += 1) {
        const response = await request(`${root()}cart/async_shipping_rates.json?${params}`, {
          credentials: 'same-origin', cache: 'no-store', headers: {Accept: 'application/json'}
        }, signal);
        const data = response.status === 202 ? null : await response.json();
        if (Array.isArray(data?.shipping_rates)) {
          return [{options: data.shipping_rates.map(rate => ({title: rate.presentment_name || rate.name,
            amount: rate.price, currency: rate.currency || context.currency,
            description: this.deliveryText(rate)}))}];
        }
        await new Promise((resolve, reject) => {
          const onAbort = () => {clearTimeout(timer); reject(new Error('ABORTED'));};
          const timer = setTimeout(() => {signal.removeEventListener('abort', onAbort); resolve();}, 400);
          signal.addEventListener('abort', onAbort, {once: true});
          if (signal.aborted) {signal.removeEventListener('abort', onAbort); onAbort();}
        });
      }
      throw new Error('SERVICE_UNAVAILABLE');
    }
  }
  customElements.define('mm-cart-shipping-rate', MMCartShippingRate);
})();
